module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepOne.svg?bfed9919";